import React from 'react'
import { Wrapper, Circle, Number, Title, Description } from './styled'

interface StepItemProps {
  stepNumber: number
  title: string
  description: string
}

const StepItem = ({ stepNumber, title, description }: StepItemProps) => {
  return (
    <Wrapper>
      <Circle>
        <Number>{stepNumber}</Number>
      </Circle>
      <div>
        <Title>{title}</Title>
        <Description>{description}</Description>
      </div>
    </Wrapper>
  )
}

export default StepItem
